(() => {
  const format = scope => {
    scope.querySelectorAll('.sx-article-reading .article-template__content').forEach(root => {
      if (root.dataset.sxFormatted) return;
      const media = 'img,video,iframe,audio,picture,svg,table,hr,form,button,input';
      const block = 'p,div,h1,h2,h3,h4,h5,h6,ul,ol,table,blockquote,figure';
      const isEmpty = e => !e.textContent.trim() && !e.matches(media) && !e.querySelector(media) && !e.id && !e.querySelector('[id],[name]');
      Array.from(root.querySelectorAll('p,div,h1,h2,h3,h4,h5,h6,strong,b,span')).reverse().forEach(e => {
        if (!isEmpty(e)) return;
        if (e.matches('span,strong,b')) e.replaceWith(document.createTextNode(' '));
        else e.remove();
      });
      Array.from(root.querySelectorAll('div')).reverse().forEach(e => {
        if (!e.closest('table,figure') && !e.id && e.querySelector(block) && !e.matches('[data-video],.video-wrapper,.media')) e.replaceWith(...e.childNodes);
      });
      const existing = Array.from(root.querySelectorAll('h1,h2,h3,h4,h5,h6')).filter(e => e.textContent.trim());
      const top = existing.length ? Math.min(...existing.map(e => Number(e.tagName.slice(1)))) : 2;
      existing.forEach(e => {
        const longIntro = e.textContent.trim().length > 160 && e === existing[0];
        const level = Math.min(4,Math.max(2,Number(e.tagName.slice(1)) - top + 2));
        const tag = longIntro ? 'p' : 'h' + level;
        if (e.tagName.toLowerCase() !== tag) {
          const replacement = document.createElement(tag);
          if (e.id) replacement.id = e.id;
          replacement.append(...e.childNodes);
          e.replaceWith(replacement);
        }
      });
      Array.from(root.querySelectorAll('p,div')).forEach(e => {
        if (e.closest('table,li,blockquote,figure') || e.querySelector(block) || e.matches('[data-video],.video-wrapper,.media')) return;
        const result = [];
        let pending = [];
        let list = null;
        const flush = () => {
          if (!pending.length) return;
          const p = document.createElement('p');
          p.append(...pending);
          pending = [];
          if (p.textContent.trim() || p.querySelector(media)) result.push(p);
        };
        const line = nodes => {
          const box = document.createElement('span');
          box.append(...nodes);
          const text = box.textContent.trim();
          if (!text && !box.querySelector(media)) return;
          const bold = Array.from(box.querySelectorAll('strong,b')).map(n => n.textContent).join('').replace(/\s/g,'');
          if (text.length <= 180 && text && bold === text.replace(/\s/g,'') && !box.querySelector(media)) {
            flush();
            list = null;
            const previous = result[result.length - 1] || e.previousElementSibling;
            const numbered = /^\d+[.)]|^\d+\.\s/.test(text);
            const heading = document.createElement(numbered && previous ? 'h3' : 'h2');
            heading.append(...box.childNodes);
            result.push(heading);
          } else if (/^[•●]\s*/.test(text) && !box.querySelector(media)) {
            flush();
            if (!list) { list = document.createElement('ul'); result.push(list); }
            const first = document.createTreeWalker(box,NodeFilter.SHOW_TEXT).nextNode();
            if (first) first.textContent = first.textContent.replace(/^[\s\u00a0]*[•●]\s*/,'');
            const item = document.createElement('li');
            item.append(...box.childNodes);
            list.append(item);
          } else {
            list = null;
            if (pending.length) pending.push(document.createElement('br'));
            pending.push(...box.childNodes);
          }
        };
        let nodes = [];
        let breaks = 0;
        Array.from(e.childNodes).forEach(node => {
          if (node.nodeType === 1 && node.tagName === 'BR') { breaks += 1; return; }
          if (node.nodeType === 3 && !node.textContent.trim() && breaks) return;
          if (breaks) {
            line(nodes); nodes = [];
            if (breaks > 1) { flush(); list = null; }
          }
          breaks = 0;
          if (node.nodeType === 1 && node.matches('img,video,iframe,audio,picture')) {
            line(nodes); nodes = []; flush(); list = null;
            const p = document.createElement('p'); p.append(node); result.push(p);
          } else nodes.push(node);
        });
        line(nodes); flush();
        if (result.length) {
          if (e.id) result[0].id = e.id;
          e.replaceWith(...result);
        }
      });
      Array.from(root.querySelectorAll('p')).forEach(p => {
        if (p.closest('table,li,blockquote,figure') || p.querySelector(media)) return;
        const text = p.textContent;
        if (text.trim().split(/\s+/).length <= 120) return;
        const boundaries = [];
        const sentence = /[.!?][”’"']?\s+(?=[A-Z“‘])/g;
        let match;
        let start = 0;
        let last = 0;
        while ((match = sentence.exec(text))) {
          const offset = match.index + match[0].length;
          const words = text.slice(start,offset).trim().split(/\s+/).length;
          if (words >= 65) {
            if (/\b(?:Mr|Mrs|Ms|Dr|Prof|e\.g|i\.e)\.\s*$/.test(text.slice(0,offset))) continue;
            boundaries.push(offset); start = offset; last = offset;
          }
        }
        if (!boundaries.length) return;
        if (text.slice(last).trim().split(/\s+/).length < 25) boundaries.pop();
        if (!boundaries.length) return;
        const walker = document.createTreeWalker(p,NodeFilter.SHOW_TEXT);
        const texts = [];
        let node; let length = 0;
        while ((node = walker.nextNode())) { texts.push({node,start:length,end:length + node.textContent.length}); length += node.textContent.length; }
        const point = offset => {
          const item = texts.find(t => offset <= t.end) || texts[texts.length - 1];
          return [item.node,Math.max(0,offset - item.start)];
        };
        let from = 0;
        const pieces = boundaries.concat(text.length).map((to,index) => {
          const range = document.createRange();
          range.setStart(...point(from)); range.setEnd(...point(to));
          const paragraph = document.createElement('p');
          if (index === 0 && p.id) paragraph.id = p.id;
          paragraph.append(range.cloneContents());
          if (index > 0) paragraph.querySelectorAll('[id]').forEach(el => el.removeAttribute('id'));
          from = to;
          return paragraph;
        });
        p.replaceWith(...pieces);
      });
      root.querySelectorAll('font').forEach(e => e.replaceWith(...e.childNodes));
      root.querySelectorAll('[style]').forEach(e => {
        const properties = ['text-align','font-family','font-size','line-height','letter-spacing','text-indent'];
        if (!e.matches(media) && !e.closest('table')) properties.push('margin','margin-top','margin-bottom','margin-left','margin-right','padding','width','max-width','min-width','height','font-weight','color','background','background-color');
        properties.forEach(property => e.style.removeProperty(property));
      });
      root.querySelectorAll('[align]').forEach(e => e.removeAttribute('align'));
      root.querySelectorAll('[class]').forEach(e => Array.from(e.classList).forEach(name => { if (/^(?:p|li|ul|ol)\d+$/.test(name)) e.classList.remove(name); }));
      root.querySelectorAll('table').forEach(table => {
        if (table.parentElement.classList.contains('sx-article-table')) return;
        const wrapper = document.createElement('div');
        wrapper.className = 'sx-article-table'; wrapper.tabIndex = 0;
        table.before(wrapper); wrapper.append(table);
      });
      const first = Array.from(root.querySelectorAll('p')).find(e => e.textContent.trim() && !e.closest('table'));
      if (first) first.classList.add('sx-article-lead');
      let previousLevel = 1;
      root.querySelectorAll('h2,h3,h4,h5,h6').forEach(e => {
        const level = Math.min(Number(e.tagName.slice(1)),previousLevel + 1);
        if (level !== Number(e.tagName.slice(1))) {
          const heading = document.createElement('h' + level);
          if (e.id) heading.id = e.id;
          heading.append(...e.childNodes);
          e.replaceWith(heading);
        }
        previousLevel = level;
      });
      root.querySelectorAll('h2,h3,h4').forEach((e,index) => {
        if (!e.id) e.id = 'article-section-' + (index + 1);
      });
      root.dataset.sxFormatted = 'true';
    });
  };
  const run = () => format(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',run,{once:true});
  else run();
  document.addEventListener('shopify:section:load',run);
})();
